import { INodeStoreSegment } from './node.interface';

export const nodeStoreSelector = (state: INodeStoreSegment) => state.node;
